const TENANT_DRAFT_PREFIX = "tenant-edit-draft:";
const COMPANY_INVITES_PREFIX = "company-common-invites:";

export function tenantEditDraftKey(userId: string, tenantId: string): string {
  return `${TENANT_DRAFT_PREFIX}${userId}:${tenantId}`;
}

export function companyCommonInvitesKey(userId: string, tenantId: string): string {
  return `${COMPANY_INVITES_PREFIX}${userId}:${tenantId}`;
}

/** Clear identity-scoped workflow hints when the authenticated session ends. */
export function clearSessionWorkflowState(): void {
  if (typeof window === "undefined") return;
  const keysToRemove: string[] = [];
  for (let index = 0; index < window.sessionStorage.length; index++) {
    const key = window.sessionStorage.key(index);
    if (key?.startsWith(TENANT_DRAFT_PREFIX) || key?.startsWith(COMPANY_INVITES_PREFIX)) {
      keysToRemove.push(key);
    }
  }
  for (const key of keysToRemove) window.sessionStorage.removeItem(key);
}
